import { setupTemplateClipboard, setUpFileClipboards } from "./clipboard";
import { createTableOfContents, filterContentsInit } from "./toc";
import { createCustomComponentList } from "./component-list";
import { injectVersion, setTheme } from "./version-replace";

document.addEventListener("DOMContentLoaded", () => {
  createTableOfContents();
  createCustomComponentList();
  setupTemplateClipboard();
  setUpFileClipboards();
  filterContentsInit();
  injectVersion();

  document.getElementById("theme-select").addEventListener("change", (e) => {
    setTheme(
      e.target.value,
      e.target.selectedOptions[0].getAttribute("data-font-url")
    );
  });
});
